const jsonSchema = [
  {
    name: 'class',
    label: 'Class',
    type: 'multiselect',
    showInList: true,
  },  
  {
    name: 'date',
    label: 'Date',
    type: 'date',
    required: true,
    showInList: true,
  },

  {
    name: 'startTime',
    label: 'Start Time',
    type: 'time',
    showInList: true,
  },
  {
    name: 'status',
    label: 'Status',
    type: 'multiselect',
    showInList: false,
  }

  // Add more fields as needed
];
export default jsonSchema;
